import { Link, useLocation } from 'react-router-dom';

import right_0xe822 from '../../assets/svgs/right_0xe822.svg';
import { CustomIcon } from '../widgets/CustomIcon';

type BackLinkProps = {
  url?: string;
};

export const BackLink = ({ url }: BackLinkProps) => {
  const location = useLocation();

  const actualPage = location.pathname;

  const lastPageIndex = actualPage.lastIndexOf('/');

  const lastPage = actualPage.substring(0, lastPageIndex);

  return (
    <Link to={url ?? lastPage} className="tw-inline-block">
      <div className="tw-flex tw-gap-2 tw-text-[#001E64] tw-underline tw-font-bold tw-w-auto">
        <CustomIcon src={right_0xe822} />
        Voltar
      </div>
    </Link>
  );
};
